import { createFileRoute } from '@tanstack/react-router';
import ChatPage from '@/chat/ChatPage';

export const Route = createFileRoute('/_workbench/chat')({ component: ChatPage });
